import React, { ReactNode } from 'react';
import { Typography } from 'antd';
import { TypographyProps as TypographyCopyProps } from 'antd/lib/typography';

export type TypographyProps = TypographyCopyProps & {
  children?: ReactNode;
};

const ProTypography: React.FC<TypographyProps> = (props) => {
  const { children, ...resProps } = props;

  return <Typography {...resProps}>{children}</Typography>;
};

export default ProTypography;
